{
  "home": {
    "heroStop": "STOPPT HUMAN SAFARI",
    "heroSave": "RETTET CHERSON",
    "heroTitle1": "Menschen",
    "heroTitle2": "sind keine Zielscheiben",
    "heroDate": "13., 14. Dezember",
    "worldwideRally": "Weltweite Kundge&shy;bung",
    "heroHashtags": "#HumansAreNotTargets #StopHumanSafari #SaveKherson",
    "infoText": "Seit Sommer 2024 setzt das russische Militär kleine Drohnen ein, um die ukrainische Zivilbevölkerung auf den Straßen von Cherson und anderer Städte in der Nähe der Front gezielt zu jagen, zu terrorisieren und zu töten. <bold>Diese Menschenjagd muss gestoppt werden. SIE können helfen.</bold> Schließen Sie sich tausenden Menschen weltweit an, um zu fordern, dass dieses Kriegsverbrechen beendet wird.",
    "seeGallery": "Siehe weltweite Poster",
    "comingSoon": "Standorte folgen in Kürze",
    "december": "Dezember",
    "dec": "Dez.",
    "october": "Oktober",
    "oct": "Okt.",
    "september": "September",
    "sep": "Sept.",
    "schedule9": "9.",
    "schedule10": "10.",
    "schedule11": "11.",
    "schedule12": "12.",
    "schedule13": "13.",
    "schedule14": "14.",
    "schedule16": "16.",
    "schedule18": "18.",
    "schedule20": "20.",
    "schedule1": "1.",
    "schedule2": "2.",
    "schedule3": "3.",
    "schedule4": "4.",
    "schedule5": "5.",
    "schedule25": "25.",
    "schedule26": "26.",
    "schedule27": "27.",
    "schedule28": "28.",
    "schedule29": "29.",
    "schedule30": "30.",
    "schedule31": "31.",
    "scheduleTBC": "Termin wird bestätigt...",
    "recommendationsTitle": "Empfehlungen der UN-Kommission",
    "recommendationsRussia": "Die Kommission fordert die Russische Föderation auf:",
    "rusRec1": "(a) Die Drohnenangriffe auf Zivilisten und auf zivile Objekte sofort zu beenden",
    "rusRec2": "(b) Alle Handlungen, die Terror unter der Zivilbevölkerung verbreiten, sofort einzustellen",
    "rusRec3": "(c) Sicherzustellen, dass die Täter von Drohnenangriffen auf Zivilisten zur Verantwortung gezogen werden",
    "recommendationsUNStates": "Die UN-Kommission empfiehlt anderen Staaten sowie regionalen und internationalen Organisationen:",
    "statesRec1": "(a) Finanzielle und technische Unterstützung der ukrainischen Regierung und zivilgesellschaftlicher Organisationen, um umfassende Hilfe für die Opfer und ihre Familien zu gewährleisten;",
    "statesRec2": "(b) Für Drittstaaten, deren Gebiet Ziel für Personen ist, die aus den besetzten Gebieten vertrieben wurden, notwendige Maßnahmen gemeinsam mit den ukrainischen Konsulardiensten zur Unterstützung dieser Personen zu ergreifen."
  },
  "resources": {
    "title": "Schlüsselressourcen",
    "linkLibraryTitle": "Link-Bibliothek",
    "linkLibraryDesc": "200 Artikel, Berichte, Interviews, Augenzeugenberichte und Medienberichterstattung",
    "humanSafariMapTitle": "Human-Safari-Karte von Tochnyi",
    "humanSafariMapDesc": "Eine interaktive Karte der Human-Safari-Angriffe in Cherson, zusammengestellt aus offen zugänglichen Meldungen lokaler Behörden und aus Angriffsvideos, die das Tochnyi-Team geolokalisiert hat.",
    "truthHoundsTitle": "Truth Hounds Bericht",
    "truthHoundsDesc": "Killzone: Wie russische Drohnen das rechte Ufer des Flusses Dnipro verwüsten",
    "hrwTitle": "Human Rights Watch Bericht über Drohnenangriffe in Cherson",
    "hrwDesc": "HRW-Bericht",
    "unReportsTitle": "Berichte des UN-Menschenrechtsrats",
    "report1": "UN-Bericht #1",
    "report3": "UN-Bericht #3",
    "guidelines": "UN-Richtlinien",
    "wikipediaTitle": "Wikipedia",
    "english": "Englisch",
    "french": "Französisch",
    "documentaryTitle": "Dokumentarfilm",
    "documentaryDesc": "www.khersonhumansafari.com"
  },
  "navbar": {
    "main": "13. - 14. Dez.",
    "eyewitnesses": "Zeugen",
    "rallies": "Fotos",
    "help": "deokkupiertes Cherson",
    "leftBank": "besetztes Cherson",
    "action": "Dez. '25",
    "oleshky": "globale Demo - Oleshky",
    "menu": "Menü"
  },
  "leftBank": {
    "pageTitle": "Drohnenbelagerung",
    "para1": "Ein akuter humanitärer Notstand betrifft 6.000 Zivilisten, die im besetzten Oleshky, Hola Prystan, Stara Zburivka und Nova Zburivka unter einer Drohnenbelagerung gefangen sind - besetzte Region Cherson. In Oleshky 1.200 - 2.000. Die Besatzungsmacht ist verpflichtet, sie zu versorgen - stattdessen werden sie von den russischen Streitkräften als menschliche Schutzschilde missbraucht, um sich hinter dieser Bevölkerung zu verstecken, während sie Human-Safari-Angriffe auf das gegenüberliegende Ufer verüben. Ukrainische Behörden und humanitäre Organisationen berichten von einer systematischen Behinderung der Evakuierung und des humanitären Zugangs.",
    "para2": "Den Zivilisten fehlt es an Nahrung, Wasser, medizinischer Versorgung, Medikamenten, Strom, Gas und Kommunikationsmitteln. Die Straßen sind stark vermint, und Drohnenaktivität schränkt die Bewegungsfreiheit ein. Seit dem 26. Mai konnten keine Fahrzeuge mehr ein- oder ausfahren. Treibstoff- und Nahrungsmittelvorräte sind nahezu erschöpft.",
    "meidasTitle": "Meidas Touch / Valor Media Network",
    "meidasVideo": "Video: „Kherson and Oleshky: Witnessing Genocide“ (12 Min.)",
    "meidasArticle": "Artikel: „The Kherson Region: How Russia Uses Civilians as a Tool of War“ (5 Min. Lesezeit)",
    "kyivPostTitle": "Kyiv Post",
    "kyivPostArticle": "Artikel: „Global Community Calls for Urgent Evacuation from Oleshky as Conditions Deteriorate“ (7 Min. Lesezeit)",
    "tellPost": "und erzähle anderen von der Drohnenbelagerung",
    "callToHelp": "SIE können helfen. So geht's",
    "donateIntro": "Diese Initiativen leisten wirkungsvolle, gezielte Hilfe direkt für Menschen, die aus Oleshky geflohen sind oder, wo es möglich ist, dort festsitzen.",
    "signTitle": "Unterschreiben",
    "signSub": "Petitionen",
    "petitionBy": "von {{name}}",
    "petitions": {
      "euParliament": "Europäisches Parlament – Petition Nr. 1439/2026 zur Einrichtung eines humanitären Evakuierungskorridors für Zivilisten, die im russisch besetzten Oleshky (Ukraine) unter Belagerung festsitzen",
      "ukParliament": "Britisches Parlament – Einrichtung eines von Großbritannien geführten humanitären Hilfskorridors nach Oleshky in der Ukraine anstreben"
    },
    "publicActionLead": "Rücke die Drohnenbelagerung dort ins Rampenlicht, wo du bist.",
    "organiseAction": "Organisiere eine Aktion.",
    "policyBody": "Die ukrainischen Behörden stehen in Konsultationen mit dem Internationalen Komitee vom Roten Kreuz über die Einrichtung eines humanitären Evakuierungskorridors aus den besetzten Ortschaften in der Region Kherson und die Sicherung des humanitären Zugangs für Nahrung, Wasser, Medikamente, Treibstoff und medizinische Hilfe. Stand Anfang Juni gibt es keinen funktionierenden Evakuierungskorridor und keinen dauerhaften Mechanismus für humanitären Zugang.",
    "documentaryTitle": "Oleshky, Kurzdokumentation",
    "downloadTitle": "Download",
    "downloadSub": "Grafiken"
  },
  "footer": {
    "addCityText": "Um Ihre Stadt hinzuzufügen, senden Sie eine E-Mail an:",
    "organiseText": "Füge deine Demo hinzu - melde dich:",
    "contact": "Kontakt:"
  },
  "byCountry": "nach Land anzeigen",
  "byDate": "nach Datum anzeigen",
  "countries": {
    "australia": "Australien",
    "austria": "Österreich",
    "bulgaria": "Bulgarien",
    "canada": "Kanada",
    "czechia": "Tschechien",
    "denmark": "Dänemark",
    "estonia": "Estland",
    "finland": "Finnland",
    "france": "Frankreich",
    "georgia": "Georgien",
    "germany": "Deutschland",
    "hungary": "Ungarn",
    "italy": "Italien",
    "japan": "Japan",
    "mexico": "Mexiko",
    "netherlands": "Niederlande",
    "norway": "Norwegen",
    "poland": "Polen",
    "romania": "Rumänien",
    "spain": "Spanien",
    "sweden": "Schweden",
    "southAfrica": "Südafrika",
    "ukraine": "Ukraine",
    "unitedKingdom": "Vereinigtes Königreich",
    "usa": "USA",
    "ireland": "Irland",
    "belgium": "Belgien"
  },
  "cities": {
    "alicante": {
      "city": "Alicante",
      "country": "Spanien",
      "time": "Alicante - Spanien, 16:00 - 17:00",
      "location": "Auditorio la Concha, Explanada de España",
      "cleanTime": "16:00 - 17:00",
      "day": "schedule13"
    },
    "barcelona": {
      "city": "Barcelona",
      "country": "Spanien",
      "time": "Barcelona - Spanien, 12:00 - 14:00",
      "location": "Placa de Sant Jaume",
      "cleanTime": "12:00 - 14:00",
      "day": "schedule14"
    },
    "berkeley": {
      "city": "Berkeley",
      "country": "USA",
      "time": "Berkeley - USA, 12:00 - 13:00",
      "location": "4th St.",
      "cleanTime": "12:00 - 13:00",
      "day": "schedule13"
    },
    "berlin": {
      "city": "Berlin",
      "country": "Deutschland",
      "time": "Berlin - Deutschland, 12:00",
      "location": "Tempelhofer Feld, Eingang Leinstr./Ecke Oderstr.",
      "cleanTime": "12:00",
      "day": "schedule14"
    },
    "bettendorf": {
      "city": "Bettendorf",
      "country": "USA",
      "time": "Bettendorf - USA, 17:30 - Filmvorführung",
      "location": "Bettendorf Public Library",
      "cleanTime": "17:30 - Filmvorführung",
      "day": "schedule11"
    },
    "birmingham": {
      "city": "Birmingham",
      "country": "Vereinigtes Königreich",
      "time": "Birmingham - Vereinigtes Königreich, 14:00 - 15:30",
      "location": "Baskerville House, Cambridge St.",
      "cleanTime": "14:00 - 15:30",
      "day": "schedule13"
    },
    "bonn": {
      "city": "Bonn",
      "country": "Deutschland",
      "time": "Bonn - Deutschland, 14:00 - 16:00",
      "location": "Poststraße, vor dem Hauptbahnhof",
      "cleanTime": "14:00 - 16:00",
      "day": "schedule14"
    },
    "bremen": {
      "city": "Bremen",
      "country": "Deutschland",
      "time": "Bremen - Deutschland, 15:00 - 18:00",
      "location": "Bahnhofsvorplatz",
      "cleanTime": "15:00 - 18:00",
      "day": "schedule14"
    },
    "budapest": {
      "city": "Budapest",
      "country": "Ungarn",
      "time": "Budapest - Ungarn, TBC",
      "location": "",
      "cleanTime": "TBC",
      "day": "scheduleTBC"
    },
    "chicago": {
      "city": "Chicago",
      "country": "USA",
      "time": "Chicago - USA, 13:00 - 15:00",
      "location": "410 N. Michigan ave. (Wrigley Building)",
      "cleanTime": "13:00 - 15:00",
      "day": "schedule14"
    },
    "constanta": {
      "city": "Constanța",
      "country": "Rumänien",
      "time": "Constanța - Rumänien, TBC",
      "location": "",
      "cleanTime": "TBC",
      "day": "scheduleTBC"
    },
    "copenhagen": {
      "city": "Kopenhagen",
      "country": "Dänemark",
      "time": "Kopenhagen - Dänemark, 14:00",
      "location": "Axeltorv",
      "cleanTime": "14:00",
      "day": "schedule14"
    },
    "dallas": {
      "city": "Dallas",
      "country": "USA",
      "time": "Dallas - USA, 12:00 - 13:00",
      "location": "Dallas City Hall Plaza",
      "cleanTime": "12:00 - 13:00",
      "day": "schedule13"
    },
    "denver": {
      "city": "Denver",
      "country": "USA",
      "time": "Denver - USA, 12:00",
      "location": "Colorado Capitol-Gebäude, Westtreppen",
      "cleanTime": "12:00",
      "day": "schedule14"
    },
    "edinburgh": {
      "city": "Edinburgh",
      "country": "Vereinigtes Königreich",
      "time": "Edinburgh - Vereinigtes Königreich, 13:00 - 15:00",
      "location": "Duke of Wellington Monument",
      "cleanTime": "13:00 - 15:00",
      "day": "schedule13"
    },
    "fortWorth": {
      "city": "Fort Worth",
      "country": "USA",
      "time": "Fort Worth - USA, 14:00 - 15:00",
      "location": "Tarrant County Courthouse",
      "cleanTime": "14:00 - 15:00",
      "day": "schedule14"
    },
    "hamburg": {
      "city": "Hamburg",
      "country": "Deutschland",
      "time": "Hamburg - Deutschland, 14:00 - 16:00",
      "location": "Mönckebergbrunnen (Mönckebergstraße)",
      "cleanTime": "14:00 - 16:00",
      "day": "schedule20"
    },
    "houghton": {
      "city": "Houghton, Michigan",
      "country": "USA",
      "time": "Houghton, Michigan - USA, 15:00",
      "location": "TBC",
      "cleanTime": "15:00",
      "day": "schedule14"
    },
    "helsinki": {
      "city": "Helsinki",
      "country": "Finnland",
      "time": "Helsinki - Finnland, 17:00 - 18:00",
      "location": "Narinkkatori",
      "cleanTime": "17:00 - 18:00",
      "day": "schedule16"
    },
    "izumo14": {
      "city": "Izumo",
      "country": "Japan",
      "time": "Izumo - Japan, 13:00",
      "location": "Izumo Taisha Shrine, 195 Kitsukihigashi, Taishacho",
      "cleanTime": "13:00",
      "day": "schedule14"
    },
    "izumo20": {
      "city": "Izumo",
      "country": "Japan",
      "time": "Izumo - Japan",
      "location": "Izumo Taisha Shrine, 195 Kitsukihigashi, Taishacho",
      "cleanTime": "",
      "day": "schedule20"
    },
    "kamloops": {
      "city": "Kamloops",
      "country": "Kanada",
      "time": "Kamloops - Kanada, 15:00 - 16:00",
      "location": "Rathaus",
      "cleanTime": "15:00 - 16:00",
      "day": "schedule13"
    },
    "kyiv": {
      "city": "Kyiv",
      "country": "Ukraine",
      "time": "Kyiv - Ukraine, 17:00 - 18:00",
      "location": "Maidan Nezalezhnosti",
      "cleanTime": "17:00 - 18:00",
      "day": "schedule14"
    },
    "leipzig": {
      "city": "Leipzig",
      "country": "Deutschland",
      "time": "Leipzig - Deutschland, 12:00 - 13:00",
      "location": "Willy-Brandt-Platz",
      "cleanTime": "12:00 - 13:00",
      "day": "schedule13"
    },
    "london": {
      "city": "London",
      "country": "Vereinigtes Königreich",
      "time": "London - Vereinigtes Königreich, 18:30 - Filmvorführung",
      "location": "Ukrainian House, 154 Holland Park Avenue",
      "cleanTime": "18:30 - Filmvorführung",
      "day": "schedule12"
    },
    "losAngeles": {
      "city": "Los Angeles",
      "country": "USA",
      "time": "Los Angeles - USA, 15:30",
      "location": "4051 Melrose Ave",
      "cleanTime": "15:30",
      "day": "schedule14"
    },
    "malaga": {
      "city": "Málaga",
      "country": "Spanien",
      "time": "Málaga - Spanien, 18:00 - Filmvorführung",
      "location": "Maydan - Centro Historico Cultural Ukraniano",
      "cleanTime": "18:00 - Filmvorführung",
      "day": "schedule13"
    },
    "manchester": {
      "city": "Manchester",
      "country": "Vereinigtes Königreich",
      "time": "Manchester - Vereinigtes Königreich, 14:00 - 15:30",
      "location": "St Peter's Square Emmeline Pankhurst Memorial",
      "cleanTime": "14:00 - 15:30",
      "day": "schedule13"
    },
    "mexicoCity": {
      "city": "Mexico City",
      "country": "Mexiko",
      "time": "Mexico City - Mexiko, 11:00",
      "location": "Alameda Central. „Amerikas“-Brunnen (zwischen Hemiciclo Juárez und Kiosk)",
      "cleanTime": "11:00",
      "day": "schedule14"
    },
    "milan": {
      "city": "Mailand",
      "country": "Italien",
      "time": "Mailand - Italien, 15:00",
      "location": "Dom zu Mailand",
      "cleanTime": "15:00",
      "day": "schedule14"
    },
    "munich": {
      "city": "München",
      "country": "Deutschland",
      "time": "München - Deutschland, 17:00 - 19:00",
      "location": "Odeonsplatz",
      "cleanTime": "17:00 - 19:00",
      "day": "schedule14"
    },
    "newYork13": {
      "city": "New York",
      "country": "USA",
      "time": "New York - USA, 16:00",
      "location": "Times Square",
      "cleanTime": "16:00",
      "day": "schedule13"
    },
    "newYork14": {
      "city": "New York",
      "country": "USA",
      "time": "New York - USA, 13:00 - 14:00",
      "location": "Times Square",
      "cleanTime": "13:00 - 14:00",
      "day": "schedule13"
    },
    "nienburg": {
      "city": "Nienburg (Weser)",
      "country": "Deutschland",
      "time": "Nienburg (Weser) - Deutschland, 17:00",
      "location": "Stettiner Str.2A",
      "cleanTime": "17:00",
      "day": "schedule13"
    },
    "oslo": {
      "city": "Oslo",
      "country": "Norwegen",
      "time": "Oslo - Norwegen, 12:00 - 13:00",
      "location": "Eidsvoll Plass, Stortinget",
      "cleanTime": "12:00 - 13:00",
      "day": "schedule14"
    },
    "ostersund": {
      "city": "Östersund",
      "country": "Schweden",
      "time": "Östersund - Schweden, 11:00 - 14:00",
      "location": "Stortorget (Hauptplatz)",
      "cleanTime": "11:00 - 14:00",
      "day": "schedule13"
    },
    "ottawa12": {
      "city": "Ottawa",
      "country": "Kanada",
      "time": "Ottawa - Kanada, 12:30 - 13:30",
      "location": "russische Botschaft",
      "cleanTime": "12:30 - 13:30",
      "day": "schedule12"
    },
    "ottawa13": {
      "city": "Ottawa",
      "country": "Kanada",
      "time": "Ottawa - Kanada, 12:00",
      "location": "US-Botschaft",
      "cleanTime": "12:00",
      "day": "schedule13"
    },
    "paris": {
      "city": "Paris",
      "country": "Frankreich",
      "time": "Paris - Frankreich, 15:30",
      "location": "Square Taras Chevchenko -> Fontaine Saint-Michel (Marsch)",
      "cleanTime": "15:30",
      "day": "schedule13"
    },
    "plovdiv": {
      "city": "Plovdiv",
      "country": "Bulgarien",
      "time": "Plovdiv - Bulgarien, 16:00 - 17:00",
      "location": "bei Levski-Haus",
      "cleanTime": "16:00 - 17:00",
      "day": "schedule14"
    },
    "prague": {
      "city": "Prag",
      "country": "Tschechien",
      "time": "Prag - Tschechien, 14:00",
      "location": "Palackého Platz",
      "cleanTime": "14:00",
      "day": "schedule13"
    },
    "rosendal": {
      "city": "Rosendal",
      "country": "Südafrika",
      "time": "Rosendal - Südafrika, 11:00",
      "location": "Büros der South African Police Service",
      "cleanTime": "11:00",
      "day": "schedule13"
    },
    "sanAndres": {
      "city": "San Andrés, Teneriffa",
      "country": "Spanien",
      "time": "San Andrés, Teneriffa - Spanien, 13:00",
      "location": "--",
      "cleanTime": "13:00",
      "day": "schedule13"
    },
    "sanDiego": {
      "city": "San Diego",
      "country": "USA",
      "time": "San Diego - USA, 14:00 - 16:00",
      "location": "El Cid Statue, Balboa Park",
      "cleanTime": "14:00 - 16:00",
      "day": "schedule14"
    },
    "sanFrancisco": {
      "city": "San Francisco",
      "country": "USA",
      "time": "San Francisco - USA, 14:00",
      "location": "Ferry Plaza, Embarcadero",
      "cleanTime": "14:00",
      "day": "schedule14"
    },
    "schwerin": {
      "city": "Schwerin",
      "country": "Deutschland",
      "time": "Schwerin - Deutschland, 19:00 - Filmvorführung",
      "location": "Internationales Haus, Ziegenmarkt 4",
      "cleanTime": "19:00 - Filmvorführung",
      "day": "schedule13"
    },
    "seattle": {
      "city": "Seattle",
      "country": "USA",
      "time": "Seattle - USA, 12:30 - 15:30",
      "location": "1005 E Union St.",
      "cleanTime": "12:30 - 15:30",
      "day": "schedule13"
    },
    "svetiVlas": {
      "city": "Sveti Vlas",
      "country": "Bulgarien",
      "time": "Sveti Vlas - Bulgarien, TBC",
      "location": "",
      "cleanTime": "TBC",
      "day": "scheduleTBC"
    },
    "sydney": {
      "city": "Sydney",
      "country": "Australien",
      "time": "Sydney - Australien, 14:00",
      "location": "Sydney Town Hall",
      "cleanTime": "14:00",
      "day": "schedule13"
    },
    "tallinn": {
      "city": "Tallinn",
      "country": "Estland",
      "time": "Tallinn - Estland, 15:00 - Filmvorführung und Rallye",
      "location": "Sõprus Cinema, Vana-Posti tn.8",
      "cleanTime": "15:00 - Filmvorführung und Rallye",
      "day": "schedule13"
    },
    "tarragona": {
      "city": "Tarragona",
      "country": "Spanien",
      "time": "Tarragona - Spanien, 18:30",
      "location": "Balcó Mediterrani",
      "cleanTime": "18:30",
      "day": "schedule14"
    },
    "theHague": {
      "city": "Den Haag",
      "country": "Niederlande",
      "time": "Den Haag - Niederlande, 13:00 - 15:00",
      "location": "Vor dem Friedenspalast / ICC",
      "cleanTime": "13:00 - 15:00",
      "day": "schedule14"
    },
    "tbilisi": {
      "city": "Tiflis",
      "country": "Georgien",
      "time": "Tiflis - Georgien, 21:00",
      "location": "Tiflis",
      "cleanTime": "21:00",
      "day": "schedule14"
    },
    "tranas": {
      "city": "Tranås",
      "country": "Schweden",
      "time": "Tranås - Schweden, 11:00 - 13:00, 13:00",
      "location": "Storgatan 49 (Kultivera)",
      "cleanTime": "11:00 - 13:00, 13:00",
      "day": "schedule13"
    },
    "vienna": {
      "city": "Wien",
      "country": "Österreich",
      "time": "Wien - Österreich, 16:00 - 18:00",
      "location": "Stock im Eisen Platz (neben Stephansdom)",
      "cleanTime": "16:00 - 18:00",
      "day": "schedule14"
    },
    "washingtonDC": {
      "city": "Washington, D.C.",
      "country": "USA",
      "time": "Washington, D.C. - USA, 12:30 - 13:30",
      "location": "Das Weiße Haus",
      "cleanTime": "12:30 - 13:30",
      "day": "schedule14"
    },
    "wroclaw": {
      "city": "Wrocław",
      "country": "Polen",
      "time": "Wrocław - Polen, 13:00",
      "location": "Plac Wolności (i retning mod People's Forum of Music)",
      "cleanTime": "13:00",
      "day": "schedule14"
    }
  },
  "help": {
    "organise": "Kontakt:",
    "email": "khersonhumansafari@gmail.com",
    "actionEmail": "antihumansafari@gmail.com",
    "share": "Teilen auf {{platform}}",
    "website": "Website",
    "facebook": "Facebook",
    "x": "X",
    "youtube": "YouTube",
    "bluesky": "Bluesky",
    "donate": "Spenden",
    "donateIntro": "Diese Initiativen leisten wirkungsvolle, gezielte Hilfe, um die Zivilbevölkerung in Cherson direkt vor Human Safari zu schützen.",
    "shareTitle": "Verbreite die Nachricht",
    "filmScreening": "Organisiere eine Vorführung des Dokumentarfilms Kherson Human Safari:",
    "howItStarted": "Wie alles begann",
    "project1": "Verletzte und vertriebene Zivilisten, Tierheime und/oder Anti-Drohnen-Schutz:",
    "project2": "Anti-Drohnen-Netze für die Straßen von Cherson:",
    "project2LinkText": "Fellas4Europe Netzlieferungen",
    "project3": "Drohnen-Detektoren und Schutzwesten für Freiwillige und Rettungsdienste:",
    "khs": {
      "name": "Kherson Human Safari",
      "desc": "Zarina Zabrisky, Journalistin und Filmemacherin, organisierte die weltweite Kundgebung und führte Regie beim Dokumentarfilm Kherson Human Safari."
    },
    "fellas": {
      "name": "Fellas4Europe",
      "desc": "Zivilistenschutz für die Straßen von Cherson – Schutz der Zivilbevölkerung vor Drohnenangriffen.",
      "foodDesc": "Lebensmittelhilfe.",
      "foodNote": "Bitte gib beim Spenden den Verwendungszweck „Food for Cherson“ an."
    },
    "ahs": {
      "name": "Anti Human Safari Projekt",
      "desc": "Drohnendetektoren und Schutzwesten für Freiwillige und Rettungsdienste in Cherson."
    },
    "pageTitle": "Stoppt Human Safari",
    "sectionIntro": "Seit dem Sommer 2024 setzt das russische Militär kleine Drohnen ein, um Zivilisten auf den Straßen von Cherson und anderen Frontstädten in der Ukraine zu jagen, zu töten und zu terrorisieren.",
    "sectionIntro2": "Es ist eine systematische und gezielte Mordkampagne: Die russischen Drohnenpiloten veröffentlichen die Aufnahmen ihrer Opfer offen in Telegram-Kanälen, um damit zu prahlen. Im Mai 2025 erkannten die Vereinten Nationen die Human Safari als andauerndes Kriegsverbrechen an.",
    "sectionIntro3": "Es wird zu wenig dagegen getan. Human Safari muss gestoppt werden.",
    "sectionIntroBold": "SIE können helfen. So geht's",
    "step2Title": "Organisieren",
    "step3Title": "Erzähl anderen davon",
    "step3Para": "Benutze die Hashtags",
    "step3ParaPost": "und erzähle anderen von Human Safari",
    "instagram": "Instagram",
    "step2Bullet1": "eine Filmvorführung",
    "step2Bullet2": "eine öffentliche Aktion",
    "step2Bullet3": "Berichterstattung in den Medien",
    "publicActionLead": "Rücke die Human Safari dort ins Rampenlicht, wo du bist.",
    "reachOutPre": "Du kannst dich für Ideen und Ressourcen",
    "reachOut": "an uns wenden",
    "reachOutPost": "",
    "newsCoverageLead": "über deine Medienkontakte. Erzähle ihnen von der Human Safari und von der Gefahr für alle gegenwärtigen und künftigen Konfliktgebiete.",
    "putInTouchPre": "Du kannst auch",
    "putInTouch": "direkt den Kontakt zu uns herstellen",
    "inform": "Informieren",
    "informSub": "dich und andere",
    "policyTitle": "Politik",
    "policyBody": "Der vorgeschlagene LORA Act (Liability for Operators and Responsible Authorities Act) würde Sanktionen entlang der gesamten Verantwortungskette einführen – von russischen FPV-Operatoren und Kommandeuren bis zur militärischen Führungsebene sowie gegen Hersteller und Zulieferer, die die Produktion und den Einsatz von Drohnen gegen Zivilisten ermöglichen.",
    "policyHelp": "Sie können auf politischer Ebene helfen?",
    "getInTouch": "Kontakt aufnehmen",
    "disdict": {
      "title": "Disinformation Dictionary",
      "link": "Human Safari"
    },
    "kryla": {
      "name": "Kryla Foundation",
      "desc": "Unterstütze sie dabei, Unterkunft und Grundbedarf für Bewohner von Oleshky zu bezahlen."
    }
  },
  "action": {
    "intro": "Wir haben mit einer weltweiten Demonstration begonnen. Jetzt kannst du:",
    "helpLink": "hier helfen"
  },
  "accounts": {
    "heading": "Berichte"
  },
  "media": {
    "close": "Schließen",
    "view": "Medien ansehen",
    "previous": "Zurück",
    "next": "Weiter",
    "andrushenkoCredit": "Oleksandr Andrushenko, Fotokorrespondent des Mediums Vgoru",
    "khersonPoliceCredit": "von @khersonpolice",
    "antypenkoCredit": "Ivan Antypenko, Fotojournalist aus Cherson",
    "telegramChannelCredit": "veröffentlicht im russischen Human-Safari-Telegram-Kanal „von Mariupol bis zu den Karpaten“",
    "fruitSellerDescription": "Obstverkäufer von einer Glasfaserdrohne verfolgt",
    "burntCarDescription": "Ausgebranntes Auto in Cherson",
    "bridgeAttackDescription": "Ein Jugendlicher wird unter einer Brücke in Cherson von einer FPV-Drohne ermordet",
    "busAttackDescription": "Einer von vielen FPV-Drohnenangriffen auf öffentliche Verkehrsmittel",
    "fpvDroneDescription": "FPV-Drohne unterwegs auf „Human Safari“",
    "antiDroneNetsDescription": "Straße in Cherson, mit Netzen gegen Drohnen der „Human Safari“ überspannt",
    "firefighterDescription": "Ein Feuerwehrmann löscht ein Auto nach einem Angriff der „Human Safari“, dahinter liegt ein Opfer"
  },
  "follow": {
    "title": "Folgen",
    "subHumanSafari": "hochwertige Quellen, die aus Cherson und über die Human Safari berichten",
    "subDroneSiege": "hochwertige Quellen, die aus Cherson und über die Drohnenbelagerung berichten",
    "localPress": "lokale ukrainischsprachige Presse",
    "lang": {
      "english": "Englisch",
      "german": "Deutsch",
      "ukrainian": "Ukrainisch"
    },
    "language": "Sprache: {{list}}",
    "languages": "Sprachen: {{list}}",
    "langSeparator": ", ",
    "zabrisky": {
      "name": "Zarina Zabrisky",
      "desc": "US-amerikanische Journalistin und Filmemacherin in Cherson, berichtet für Byline Times und Euromaidan Press; führte Regie beim Dokumentarfilm Kherson Human Safari."
    },
    "naber": {
      "name": "Ibrahim Naber",
      "desc": "Chefreporter der Welt; berichtet immer wieder über die Human Safari in Cherson."
    },
    "kelley": {
      "name": "Brendan Kelley",
      "desc": "Schreibt Kherson Weekly, eine laufende Chronik russischer Drohnenangriffe auf Zivilisten in Cherson und den umliegenden Dörfern."
    },
    "vgoru": {
      "name": "Vgoru",
      "desc": "Unabhängige Medienplattform aus der Region Cherson, berichtet über das Leben unter Beschuss und unter Besatzung."
    },
    "suspilne": {
      "name": "Suspilne Cherson",
      "desc": "Die Cherson-Redaktion des öffentlich-rechtlichen Rundfunks der Ukraine."
    },
    "most": {
      "name": "MOST",
      "desc": "Lokale Nachrichtenagentur aus Cherson, berichtet über die Stadt und die Region."
    }
  },
  "rallies": {
    "oleshky2026": {
      "heroStop": "STOPPT DIE DROHNEN&shy;BELAGERUNG",
      "heroSave": "RETTET OLESHKY",
      "worldwideRally": "Weltweite Demo",
      "heroDate": "Oktober",
      "infoText1": "Tausende Zivilisten sind in Oleshky, Hola Prystan, Stara Zburivka und Nova Zburivka unter einer Drohnenbelagerung eingeschlossen. Russische Truppen missbrauchen sie als menschliche Schutzschilde und verstecken sich hinter ihnen, um Human-Safari-Drohnenangriffe auf das gegenüberliegende Ufer auszuführen.",
      "infoText2": "Die Lage ist akut – es fehlt an Lebensmitteln, Wasser, medizinischer Versorgung, Medikamenten, Strom, Gas und Kommunikation. Die Straßen sind stark vermint, und Drohnen schränken jede Bewegung ein. <bold>SIE können helfen. Schließen Sie sich tausenden Menschen weltweit an, um ein Ende der Drohnenbelagerung zu fordern.</bold>",
      "imageAlt": "Ein verhungernder Hund zwischen menschlichen Knochen im zerstörten Oleshky, unter einem roten Himmel voller Drohnen, mit den Worten Stop Russian Drone Siege",
      "demandsTitle": "Wir fordern:",
      "demand1": "sichere und wirksame humanitäre Korridore nach Oleshky und in andere betroffene Gemeinden.",
      "demand2": "sofortige humanitäre Hilfe und Unterstützung für die Opfer der Human-Safari-Angriffe.",
      "demand3": "angemessene Sanktionen gegen Personen und Lieferketten, die für Angriffe auf Zivilisten verantwortlich sind.",
      "demand4": "Maßnahmen, um den Einsatz kleiner Drohnen zur systematischen Jagd auf Zivilisten und deren Terrorisierung in Cherson, in der Ukraine und anderswo abzuschrecken.",
      "cities": {
        "edinburgh": {
          "city": "Edinburgh",
          "country": "Vereinigtes Königreich",
          "time": "Edinburgh - Vereinigtes Königreich, 14:00",
          "location": "Duke of Wellington Monument",
          "cleanTime": "14:00",
          "day": "schedule26"
        },
        "birmingham": {
          "city": "Birmingham",
          "country": "Vereinigtes Königreich",
          "time": "Birmingham - Vereinigtes Königreich, 14:00 - 16:00",
          "location": "Gegenüber der Hall of Memory, B1 2ND",
          "cleanTime": "14:00 - 16:00",
          "day": "schedule3"
        },
        "vienna": {
          "city": "Wien",
          "country": "Österreich",
          "time": "Wien - Österreich, 15:00 - 17:00",
          "location": "Stephansplatz, 1010 Wien",
          "cleanTime": "15:00 - 17:00",
          "day": "schedule27"
        },
        "munich": {
          "city": "München",
          "country": "Deutschland",
          "time": "München - Deutschland, 15:00 - 17:00",
          "location": "Marienplatz, 80331 München",
          "cleanTime": "15:00 - 17:00",
          "day": "schedule3"
        },
        "london": {
          "city": "London",
          "country": "Vereinigtes Königreich",
          "time": "London - Vereinigtes Königreich, 16:00 - 18:00",
          "location": "Downing Street",
          "cleanTime": "16:00 - 18:00",
          "day": "schedule27"
        },
        "manchester": {
          "city": "Manchester",
          "country": "Vereinigtes Königreich",
          "time": "Manchester - Vereinigtes Königreich, 14:00 - 15:30",
          "location": "St Peter's Square",
          "cleanTime": "14:00 - 15:30",
          "day": "schedule26"
        },
        "sydney": {
          "city": "Sydney",
          "country": "Australien",
          "time": "Sydney - Australien, 14:00",
          "location": "Sydney Town Hall",
          "cleanTime": "14:00",
          "day": "schedule26"
        },
        "paris": {
          "city": "Paris",
          "country": "Frankreich",
          "time": "Paris - Frankreich, 15:30 - 18:30",
          "location": "Von der Kirche Saint-Volodymyr zur Place Saint-Michel",
          "cleanTime": "15:30 - 18:30",
          "day": "schedule26"
        },
        "parisSep30": {
          "city": "Paris",
          "country": "Frankreich",
          "time": "Paris - Frankreich, 18:00",
          "location": "Metrostation Rambuteau",
          "cleanTime": "18:00",
          "day": "schedule30"
        },
        "lyon": {
          "city": "Lyon",
          "country": "Frankreich",
          "time": "Lyon - Frankreich, 14:00",
          "location": "Place de la Comédie",
          "cleanTime": "14:00",
          "day": "schedule27"
        },
        "dublin": {
          "city": "Dublin",
          "country": "Irland",
          "time": "Dublin - Irland, 13:00",
          "location": "The GPO (Hauptpostamt)",
          "cleanTime": "13:00",
          "day": "schedule4"
        },
        "brussels": {
          "city": "Brüssel",
          "country": "Belgien",
          "time": "Brüssel - Belgien, 10:00 - 11:00",
          "location": "La Petite rue de la Loi, 1040 Brüssel (Schuman-Kreisverkehr)",
          "cleanTime": "10:00 - 11:00",
          "day": "schedule28"
        },
        "ottawa": {
          "city": "Ottawa",
          "country": "Kanada",
          "time": "Ottawa - Kanada, 12:30 - 13:30",
          "location": "Russische Botschaft, 285 Charlotte St",
          "cleanTime": "12:30 - 13:30",
          "day": "schedule2"
        },
        "nantes": {
          "city": "Nantes",
          "country": "Frankreich",
          "time": "Nantes - Frankreich, 15:00 - 16:30",
          "location": "Place Royale",
          "cleanTime": "15:00 - 16:30",
          "day": "schedule3"
        },
        "gdansk": {
          "city": "Danzig",
          "country": "Polen",
          "time": "Danzig - Polen, 18:30 - 19:30",
          "location": "Długi Targ (Langer Markt), am Neptunbrunnen",
          "cleanTime": "18:30 - 19:30",
          "day": "schedule27"
        },
        "chicago": {
          "city": "Chicago",
          "country": "USA",
          "time": "Chicago - USA, 13:00",
          "location": "410 N. Michigan ave. (Wrigley Building)",
          "cleanTime": "13:00",
          "day": "schedule27"
        },
        "chicagoOct4": {
          "city": "Chicago",
          "country": "USA",
          "time": "Chicago - USA, 13:00",
          "location": "410 N. Michigan ave. (Wrigley Building)",
          "cleanTime": "13:00",
          "day": "schedule4"
        },
        "chicagoOct11": {
          "city": "Chicago",
          "country": "USA",
          "time": "Chicago - USA, 13:00",
          "location": "410 N. Michigan ave. (Wrigley Building)",
          "cleanTime": "13:00",
          "day": "schedule11"
        },
        "chicagoOct18": {
          "city": "Chicago",
          "country": "USA",
          "time": "Chicago - USA, 13:00",
          "location": "410 N. Michigan ave. (Wrigley Building)",
          "cleanTime": "13:00",
          "day": "schedule18"
        },
        "dresden": {
          "city": "Dresden",
          "country": "Deutschland",
          "time": "Dresden - Deutschland, 14:00",
          "location": "Neumarkt",
          "cleanTime": "14:00",
          "day": "schedule4"
        },
        "malaga": {
          "city": "Málaga",
          "country": "Spanien",
          "time": "Málaga - Spanien, 19:00",
          "location": "Plaza de la Marina",
          "cleanTime": "19:00",
          "day": "schedule3"
        },
        "londonSep29": {
          "city": "London",
          "country": "Vereinigtes Königreich",
          "time": "London - Vereinigtes Königreich, 18:00",
          "location": "Trafalgar Square",
          "cleanTime": "18:00",
          "day": "schedule29"
        },
        "plovdiv": {
          "city": "Plovdiv",
          "country": "Bulgarien",
          "time": "Plovdiv - Bulgarien, 17:00",
          "location": "Hauptstraße (Glavnata), an der Kamenitza-Treppe / am „Together“-Schriftzug",
          "cleanTime": "17:00",
          "day": "schedule3"
        },
        "budapest": {
          "city": "Budapest",
          "country": "Ungarn",
          "time": "Budapest - Ungarn, 17:00 - 20:00",
          "location": "Szent István tér (Stephansplatz)",
          "cleanTime": "17:00 - 20:00",
          "day": "schedule30"
        },
        "londonOct1": {
          "city": "London",
          "country": "Vereinigtes Königreich",
          "time": "London - Vereinigtes Königreich, 17:00",
          "location": "Trafalgar Square",
          "cleanTime": "17:00",
          "day": "schedule1"
        },
        "londonOct3": {
          "city": "London",
          "country": "Vereinigtes Königreich",
          "time": "London - Vereinigtes Königreich, 12:00",
          "location": "Trafalgar Square",
          "cleanTime": "12:00",
          "day": "schedule3"
        },
        "hamburg": {
          "city": "Hamburg",
          "country": "Deutschland",
          "time": "Hamburg - Deutschland, 14:00 - 16:00",
          "location": "Landungsbrücken, Jan-Fedder-Promenade, Höhe Brücke 1, 20359 Hamburg",
          "cleanTime": "14:00 - 16:00",
          "day": "schedule3"
        },
        "kiel": {
          "city": "Kiel",
          "country": "Deutschland",
          "time": "Kiel - Deutschland, 15:00 - 16:00",
          "location": "Holstenstraße",
          "cleanTime": "15:00 - 16:00",
          "day": "schedule4"
        },
        "oslo": {
          "city": "Oslo",
          "country": "Norwegen",
          "time": "Oslo - Norwegen",
          "location": "Eidsvolls plass",
          "cleanTime": "",
          "day": "schedule3"
        },
        "leipzig": {
          "city": "Leipzig",
          "country": "Deutschland",
          "time": "Leipzig - Deutschland, 17:00 - 18:00",
          "location": "Hauptbahnhof (Willy-Brandt-Platz)",
          "cleanTime": "17:00 - 18:00",
          "day": "schedule5"
        },
        "londonOct9": {
          "city": "London",
          "country": "Vereinigtes Königreich",
          "time": "London - Vereinigtes Königreich, 17:00",
          "location": "Trafalgar Square",
          "cleanTime": "17:00",
          "day": "schedule9"
        },
        "londonOct10": {
          "city": "London",
          "country": "Vereinigtes Königreich",
          "time": "London - Vereinigtes Königreich, 13:00",
          "location": "Trafalgar Square",
          "cleanTime": "13:00",
          "day": "schedule10"
        },
        "dublinOct11": {
          "city": "Dublin",
          "country": "Irland",
          "time": "Dublin - Irland, 13:00",
          "location": "The GPO (Hauptpostamt)",
          "cleanTime": "13:00",
          "day": "schedule11"
        },
        "dublinOct25": {
          "city": "Dublin",
          "country": "Irland",
          "time": "Dublin - Irland, 14:00",
          "location": "The GPO (Hauptpostamt)",
          "cleanTime": "14:00",
          "day": "schedule25"
        },
        "nantesOct31": {
          "city": "Nantes",
          "country": "Frankreich",
          "time": "Nantes - Frankreich, 15:00 - 16:30",
          "location": "Place Royale",
          "cleanTime": "15:00 - 16:30",
          "day": "schedule31"
        }
      },
      "posterStopSiege": "Stoppt die russische Drohnenbelagerung",
      "posterNoRoadOut": "Die Wege nach Oleshky hinein und hinaus sind blockiert",
      "posterHumanitarianCatastrophe": "Oleshky. Eine humanitäre Katastrophe unter Besatzung",
      "seeGallery": "Poster ansehen / herunterladen"
    },
    "artBy": "Kunst: {{name}}",
    "downloadPoster": "Poster herunterladen",
    "reel": {
      "download": "Video herunterladen (MP4)"
    },
    "addDemo": {
      "title": "füge deine Demo hinzu",
      "where": "wo: Stadt/Ort",
      "contact": "E-Mail/Nummer",
      "message": "nachricht: wen du vertrittst, deine Demo ist bestätigt oder in Planung, Link zur Online-Ankündigung, weitere Details",
      "submit": "Absenden",
      "sending": "Wird gesendet…",
      "thanks": "Danke! Wir melden uns.",
      "error": "Etwas ist schiefgelaufen. Bitte versuche es erneut.",
      "contactInvalid": "Bitte gib eine gültige E-Mail-Adresse oder eine Telefonnummer mit Ländervorwahl ein (z. B. +49 151 23456789).",
      "date": "Datum",
      "time": "Beginn (Ortszeit)",
      "whereInvalid": "Bitte gib den Namen einer Stadt oder eines Ortes ein, z. B. Berlin oder Kyjiw, Ukraine.",
      "datePlaceholder": "Datum: TT/MM"
    }
  },
  "seo": {
    "oleshky": {
      "title": "Stoppt die Drohnenbelagerung — Rettet Oleshky | Weltweite Demos",
      "description": "Russische Drohnen belagern Tausende Zivilisten im besetzten Oleshky in der Ukraine, abgeschnitten von Nahrung, Wasser und Medikamenten. Finde eine Demo in deiner Nähe und fordere einen sicheren Ausweg."
    },
    "leftBank": {
      "title": "Drohnenbelagerung von Oleshky und der besetzten Region Cherson",
      "description": "Tausende Zivilisten sind unter russischer Drohnenbelagerung im besetzten Oleshky, Hola Prystan und umliegenden Dörfern gefangen. Erfahre, was geschieht und wie du helfen kannst."
    },
    "help": {
      "title": "Stoppt Human Safari — Russische Drohnen jagen Zivilisten in Cherson",
      "description": "Russische Drohnen jagen Zivilisten in Cherson, Ukraine. Erfahre mehr über das Kriegsverbrechen Human Safari und wie du helfen kannst, es zu stoppen."
    },
    "action": {
      "title": "Weltweite Kundgebung Dezember 2025 — Stoppt Human Safari",
      "description": "Fotos, Plakate und Orte der weltweiten Kundgebung im Dezember 2025 gegen russische Drohnenangriffe auf Zivilisten in Cherson, Ukraine."
    },
    "rallies": {
      "title": "Fotos der Kundgebungen — Stoppt Human Safari",
      "description": "Fotos von Kundgebungen weltweit gegen russische Drohnenangriffe auf Zivilisten in Cherson, Ukraine."
    },
    "resources": {
      "title": "Human Safari — Berichte, Artikel und Zeugenaussagen",
      "description": "Berichte, Artikel, Interviews und Augenzeugenberichte zu russischen Drohnenangriffen auf Zivilisten in Cherson, Ukraine."
    },
    "reel": {
      "title": "Rettet Oleshky — Demo-Video",
      "description": "Video der weltweiten Demos „Rettet Oleshky“, Oktober 2026."
    }
  }
}
